import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

const useGetAdmins = demoId => {
  const { data } = useQuery(
    ['admins'],
    () => get('/client_admin/board_admins', { id: demoId }),
    {
      initialData: [],
    },
  );

  return data;
};

export default useGetAdmins;
